"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _constants = require("../constants");
var styleOverrides = {
    fab: {
        width: 40,
        height: 40,
        backgroundColor: _constants.colors.commonColors.white,
        color: _constants.colors.text.primary,
        '&:hover': {
            backgroundColor: _constants.colors.commonColors.white
        }
    }
};
var _default = exports.default = {
    styleOverrides: styleOverrides
}; //# sourceMappingURL=MuiSpeedDial.js.map
